import React, { useEffect } from "react";
import { useBlocker } from "react-router-dom";
import { useIntl } from "react-intl";
import { useModal } from "@/hook";
import Button from "@/component/Button";
import { Modal } from ".";


const ROUTING_BLOCK_DIALOG_ID = "routing-block-dialog-id";

interface RoutingBlockDialogProps {
    isBlocking: boolean;
    title: string;
    description: string;
}

const RoutingBlockDialog: React.FC<RoutingBlockDialogProps> = ({ isBlocking, title, description }) => {
    const intl = useIntl();
    const modal = useModal();
    const blocker = useBlocker(isBlocking);

    const onClickCancel = () => {
        blocker.reset?.();
        modal.close(ROUTING_BLOCK_DIALOG_ID);
    };

    const onClickConfirm = () => {
        blocker.proceed?.();
        modal.close(ROUTING_BLOCK_DIALOG_ID);
    };

    useEffect(() => {
        if (blocker.state === "blocked") {
            modal.open(ROUTING_BLOCK_DIALOG_ID);
        }
        // eslint-disable-next-line
    }, [blocker.state]);

    return (
        <Modal id={ROUTING_BLOCK_DIALOG_ID}
               size="sm"
               title={title}
               closeButtonAriaLabel={intl.formatMessage({ id: "b0003" })}
               onClose={onClickCancel}
        >
            <div className="modal-body">
                <div className="modal-description whitespace-pre-wrap">
                    {description}
                </div>

                <div className="modal-btn-group">
                    <Button variant="secondary"
                            size="sm"
                            onClick={onClickCancel}
                    >
                        {intl.formatMessage({ id: "b0002" })}
                    </Button>
                    <Button variant="primary"
                            size="sm"
                            onClick={onClickConfirm}
                    >
                        {intl.formatMessage({ id: "b0001" })}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default RoutingBlockDialog;
